export default __webpack_public_path__ + "static/media/ISWEC-2.d5110901.pdf";